import { SENTIMENT as _SENTIMENT } from "@/constants";
import { msg } from "@lingui/core/macro";
import {
  AngryIcon,
  FrownIcon,
  LaughIcon,
  MehIcon,
  SmileIcon,
} from "lucide-react";

export const SENTIMENT = {
  very_positive: {
    value: _SENTIMENT.VERY_POSITIVE,
    label: msg`Väldigt positivt`,
    pluralLabel: msg`Väldigt positiva`,
    icon: LaughIcon,
  },
  positive: {
    value: _SENTIMENT.POSITIVE,
    label: msg`Positivt`,
    pluralLabel: msg`Positiva`,
    icon: SmileIcon,
  },
  neutral: {
    value: _SENTIMENT.NEUTRAL,
    label: msg`Neutralt`,
    pluralLabel: msg`Neutrala`,
    icon: MehIcon,
  },
  negative: {
    value: _SENTIMENT.NEGATIVE,
    label: msg`Negativt`,
    pluralLabel: msg`Negativa`,
    icon: FrownIcon,
  },
  very_negative: {
    value: _SENTIMENT.VERY_NEGATIVE,
    label: msg`Väldigt negativt`,
    pluralLabel: msg`Väldigt negativa`,
    icon: AngryIcon,
  },
};

export const SENTIMENT_OPTIONS = [
  SENTIMENT.very_positive,
  SENTIMENT.positive,
  SENTIMENT.neutral,
  SENTIMENT.negative,
  SENTIMENT.very_negative,
];
